module.exports = __webpack_public_path__ + "img/7_135.b239da03.png";